import React from 'react';
import { useEffect, useState } from 'react';
import './App.css';
import Home from './components/Home/Home';
import NavBar from './components/NavBar/NavBar';
import Loader from './components/utilitys/Loader';




function App() {

  const [isLoading, setIsLoading]= useState(true);

  useEffect(()=> {
    setTimeout(()=>{
      setIsLoading(false);
    },2500)
  })
  

  return (
    <div >
     {
      isLoading?(<Loader></Loader>):( 
      <div>
     <NavBar></NavBar>
     <Home></Home>
      </div>
      )
     }
    </div>
  );
}

export default App;

// https://mhnpd.github.io/react-loader-spinner/
//react-loader-snipper